import { TM } from "@litres-libs/tracker-manager";

import { getConfig } from "lib/get-config";
import { useTranslation } from "lib/i18n/use-translation";
import { useToc } from "lib/toc/use-toc";
import { getBuyUrl } from "lib/urls/buy";

import { Bookmark } from "./bookmark";
import { Bookmarks } from "./bookmarks";
import { Fullscreen } from "./fullscreen";
import css from "./header.module.scss";
import { Help } from "./help";
import { Settings } from "./settings";
import { Title } from "./title";
import { Toc } from "./toc";

export function Header() {
  const { t } = useTranslation();
  const { toc } = useToc();
  const { trials, texttrialbutton, showSaleBlock } = getConfig();
  const isFragment = trials === 1;
  const artId = toc?.Meta.ArtID;

  const handleBuyClick = () => {
    if (showSaleBlock) {
      TM.sendEventSync({
        eventType: "fragment_click_buy",
        params: {
          id: artId,
          source_internal: "book_card",
        },
      });
    }

    window.location.href = getBuyUrl();
  };

  return (
    <div className={css.root}>
      <div className={css.title}>
        <Title />
      </div>
      <div className={css.settings}>
        {isFragment && (
          <a className={css.buyButton} onClick={handleBuyClick}>
            {texttrialbutton || t("Купить")}
          </a>
        )}
        <div className={css.help}>
          <Help />
        </div>
        <Toc />
        <div className={css.fullSettings}>
          <Bookmarks />
          <Settings />
          <Bookmark />
        </div>
        <Fullscreen />
      </div>
    </div>
  );
}
